<template>
  <div class="panel mt-20">
    <el-form
      label-position="left"
      ref="setForm"
      :model="setForm"
      :rules="rules"
      label-width="100px"
      size="small"
      style="width: 400px"
    >
      <el-form-item label="系统使用权限">
        <div style="display: flex; align-items: center">
          <el-switch v-model="setForm.on"></el-switch>
          <span class="font-12 ml-5">{{ setForm.on ? '开启' : '关闭' }}</span>
        </div>
      </el-form-item>
      <template v-if="setForm.on">
        <el-form-item label="管理员姓名" prop="contact_name">
          <el-input
            v-model="setForm.contact_name"
            placeholder="登录该系统的用户名"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item label="管理员电话" prop="contact_mobile">
          <el-input
            v-model="setForm.contact_mobile"
            autocomplete="off"
            maxlength="11"
            placeholder="登录该系统的手机号"
          ></el-input>
        </el-form-item>
        <el-form-item label="坐席人数">
          <el-input-number
            v-model="setForm.seats"
            :min="1"
            size="small"
          ></el-input-number>
        </el-form-item>
        <el-form-item label="登录方式">
          <el-checkbox-group v-model="setForm.entrances">
            <el-checkbox
              v-for="(v, k) in LoginEntrances"
              :key="k"
              :label="parseInt(k)"
              >{{ v }}</el-checkbox
            >
          </el-checkbox-group>
        </el-form-item>
      </template>
      <el-form-item label="">
        <el-button
          size="small"
          :disabled="submiting"
          type="primary"
          @click="submit"
          >保存</el-button
        >
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { LoginEntrances } from '../../config/global'
import { updateDealerUsage } from '../../service/getData'

export default {
  props: {
    usage: {},
  },
  data() {
    return {
      LoginEntrances,
      submiting: false,
      setForm: {
        on: false,
        contact_name: '',
        contact_mobile: '',
        seats: 0,
        entrances: [],
        dealer_id: 0,
      },

      rules: {
        contact_name: [
          { required: true, message: '请填写该项', trigger: 'blur' },
          {
            min: 2,
            max: 40,
            message: '长度在 2 到 40 个字符',
            trigger: 'blur',
          },
        ],
        contact_mobile: [
          {
            required: true,
            pattern: /^1\d{10}$/,
            message: '手机号错误',
            trigger: 'blur',
          },
        ],
      },
    }
  },
  created() {
    if (this.usage) {
      this.setForm = this.usage
    }
  },
  methods: {
    async submit() {
      this.$refs.setForm.validate(async (valid) => {
        if (valid) {
          this.submiting = true
          let res = await updateDealerUsage(this.setForm)
          if (res.code == 0) {
            this.$message.success('设置成功')
          }
          this.submiting = false
        }
      })
    },
  },
}
</script>